import {isBloodPressureMeasurement, isEcgMeasurement, MeasurementType} from "../../../measurement-models";
import {ReleaseToggleState} from "../../../../tools/release-toggles/release-toggle-state";

export function isAnalysableType(type: MeasurementType) {
  return isEcgMeasurement(type)
    || isBloodPressureMeasurement(type)
    || (type === "SLEEP" && feature573Released());
}

function feature573Released(): boolean {
  return ReleaseToggleState.getInstance().isReleased("DOCTOR_ANALYSES_SLEEP_573");
}
